import { render, staticRenderFns } from "./staff_bills.vue?vue&type=template&id=6c9ae41d"
import script from "./staff_bills.vue?vue&type=script&lang=js"
export * from "./staff_bills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports